import "./pencilBanner.scss";
import { initSwiperMount } from "shared/vanilla/initSwiperMount";

initSwiperMount();